import React from "react";
import { throwNewToastSuccess } from "../../Utils/MainUtils";
import BasicCopyButton from "../BasicCopyButton";
import styled from "./styled.module.scss";

interface IReadableBasicInputProps {
  inputValue: string;
  size?: "md" | "lg";
  successMessage?: string;
  isCopyable?: boolean;
}

const ReadableBasicInput: React.FC<IReadableBasicInputProps> = ({
  inputValue,
  size = "lg",
  successMessage = "Referral link copied successfully",
  isCopyable = true,
}) => {
  const handleSelectWalletKey = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target) {
      event.target.select();
    }
  };

  const handleCopyClick = () => {
    if (inputValue) {
      navigator.clipboard
        .writeText(inputValue)
        .then(() => {
          throwNewToastSuccess(successMessage);
        })
        .catch((error) => {
          console.error("Не удалось скопировать текст: ", error);
        });
    }
  };

  return (
    <label className={styled.readable_input_label}>
      <input
        className={styled.readable_input}
        value={inputValue}
        readOnly
        onFocus={handleSelectWalletKey}
        data-size={size}
      />
      {isCopyable ? (
        <div className={styled.readable_input_copy_button}>
          <BasicCopyButton onClick={handleCopyClick} />
        </div>
      ) : null}
    </label>
  );
};

export default ReadableBasicInput;
